import React, { useState } from 'react';
import Layout from '../components/Layout';
import { contactService } from '../services/firebaseService';

const ContactPage: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const submitForm = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      await contactService.submitContactForm({ name, email, subject, message });
      setStatus('success');
      setName(''); setEmail(''); setSubject(''); setMessage('');
    } catch (err) {
      setStatus('error');
    }
  };

  return (
    <Layout>
      <div className="container">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
        <form onSubmit={submitForm} style={{ maxWidth: 600 }}>
          <div className="form-group">
            <label className="form-label" htmlFor="name">Name</label>
            <input 
              id="name" 
              className="form-input" 
              value={name} 
              onChange={(e) => setName(e.target.value)} 
              required 
            />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="email">Email</label>
            <input 
              id="email" 
              type="email" 
              className="form-input" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required 
            />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="subject">Subject</label>
            <input 
              id="subject" 
              className="form-input" 
              value={subject} 
              onChange={(e) => setSubject(e.target.value)} 
            />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="message">Message</label>
            <textarea 
              id="message" 
              className="form-textarea" 
              value={message} 
              onChange={(e) => setMessage(e.target.value)} 
              rows={4} 
              required 
            />
          </div>
          <button className="btn btn-primary" disabled={status === 'submitting'}>
            {status === 'submitting' ? 'Submitting...' : 'Send Message'}
          </button>
        </form>
        {status === 'success' && (
          <div className="success" style={{ marginTop: '1rem' }}>
            Thanks! Your message has been sent. We'll get back to you soon.
          </div>
        )}
        {status === 'error' && (
          <div className="error" style={{ marginTop: '1rem' }}>
            Something went wrong. Please try again.
          </div>
        )}
      </div>
    </Layout>
  );
};

export default ContactPage;

